import { faDownload } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Tooltip } from "@mui/joy";
import { saveAs } from "file-saver";
import { memo, useCallback } from "react";

interface ExportAsCsvButtonProps {
  tooltipTitle?: string;
  getHeaders: () => string[];
  getRows: () => string[][] | undefined;
  fileName?: string;
}

const ExportAsCsvButton = memo<ExportAsCsvButtonProps>(
  ({
    tooltipTitle = "Download table as a CSV",
    getHeaders,
    getRows,
    fileName = "export.csv",
  }) => {
    const handleExportCsv = useCallback(() => {
      if (getHeaders && getRows) {
        // Create CSV content with proper escaping
        const rows = getRows() || [];
        const csvContent = [
          getHeaders().join(","),
          ...rows.map((row) =>
            row
              .map((cell) => {
                // Escape quotes and wrap in quotes if needed
                const cellStr = String(cell || "");
                if (
                  cellStr.includes(",") ||
                  cellStr.includes('"') ||
                  cellStr.includes("\n")
                ) {
                  return `"${cellStr.replace(/"/g, '""')}"`;
                }
                return cellStr;
              })
              .join(",")
          ),
        ].join("\n");

        // Create and download file
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
        saveAs(blob, fileName);
      }
    }, [getHeaders, getRows, fileName]);
    return (
      <Tooltip title={tooltipTitle}>
        <IconButton onClick={handleExportCsv}>
          <FontAwesomeIcon icon={faDownload} />
        </IconButton>
      </Tooltip>
    );
  }
);

ExportAsCsvButton.displayName = "ExportAsCsvButton";
export default ExportAsCsvButton;
